import { render, staticRenderFns } from "./game-trip-summary-card.vue?vue&type=template&id=fe4fd758&scoped=true&"
import script from "./game-trip-summary-card.vue?vue&type=script&lang=ts&"
export * from "./game-trip-summary-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4fd758",
  null
  
)

export default component.exports